export const config = {
    // baseUrl: "https://api.canarioair.com/web/",
    // baseUrl: "https://canario-api2.ar-sw.com/web/",
    // baseSourceUrl: "https://api.canarioair.com",
    // baseSourceUrl: "https://canario-api2.ar-sw.com",
    // baseUrl: "http://localhost:3002/web/",
    // socketUrl: "https://api.canarioair.com",
    // socketUrl: "https://canario-api2.ar-sw.com",
    // socketUrl: "http://localhost:3100",
    // baseUrl: "https://api.goficial.net/web/",
    // baseUrl: "https://canario-api2.ar-sw.com/web/",
    // socketUrl: "https://api.goficial.net",
    // socketUrl: "https://canario-api2.ar-sw.com",
    // socketUrl: "http://localhost:3100",
    // baseUrl: "http://localhost:3001/web/",
    socketUrl: "https://GIS-api.ar-sw.com",
    baseUrl: "https://GIS-api.ar-sw.com/web/",

};